import { CheckIcon, Trash2Icon, XIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

export interface ContentBriefEditorActionsProps {
  hasComment: boolean
  onSave: (e: React.MouseEvent) => void
  onCancel: (e: React.MouseEvent) => void
  onDelete: (e: React.MouseEvent) => void
}

export const ContentBriefEditorActions: React.FC<ContentBriefEditorActionsProps> = ({
  hasComment,
  onSave,
  onCancel,
  onDelete,
}): ReactNode => (
  <div className="mt-2 flex items-center justify-between">
    <div>
      {hasComment && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onDelete}
          className="content-brief-comment-delete h-7 cursor-pointer px-2 text-destructive hover:text-destructive"
        >
          <Trash2Icon className="size-3.5" />
          Delete
        </Button>
      )}
    </div>
    <div className="flex gap-1">
      <Button
        variant="ghost"
        size="sm"
        onClick={onCancel}
        className="content-brief-comment-cancel h-7 cursor-pointer px-2"
      >
        <XIcon className="size-3.5" />
        Cancel
      </Button>
      <Button
        size="sm"
        onClick={onSave}
        className="content-brief-comment-save h-7 cursor-pointer px-2"
      >
        <CheckIcon className="size-3.5" />
        Save
      </Button>
    </div>
  </div>
)
